import React from "react";
import { PrimaryCta } from "../../../components";

const AnalyticsHeaderTop = ({
    orgData,
    campaignReport,
    reportType,
    onReportTypeToggle,
    onShareClick,
    onDownloadClick,
    pdfLoading,
    isReportGenerated,
    campaignDetail,
}) => {
    return (
        <div className="analytics-header-top">
            <div className="analytics-header-right">
                <div className="analytics-header-buttons">
                    {orgData?.org_data?.organization_type === "AGENCY" &&
                        campaignDetail?.campaign_data?.is_marketplace !== 1 &&
                        (campaignReport || isReportGenerated) && (
                            <>
                                <div className="report-type-toggle">
                                    <button
                                        className={`toggle-option ${reportType === "user" ? "active" : ""}`}
                                        onClick={() =>
                                            reportType !== "user" &&
                                            onReportTypeToggle()
                                        }
                                    >
                                        Self Report
                                    </button>
                                    <button
                                        className={`toggle-option ${reportType === "client" ? "active" : ""}`}
                                        onClick={() =>
                                            reportType !== "client" &&
                                            onReportTypeToggle()
                                        }
                                    >
                                        Client Report
                                    </button>
                                </div>
                            </>
                        )}
                </div>

                {(campaignReport || isReportGenerated) && (
                    <div className="analytics-header-actions">
                        {/* <PrimaryCta
                            invertSmall
                            text="Share"
                            padding="0px 12px"
                            fontSize="font_size_small"
                            iconPosition="left"
                            iconName="shareIcons"
                            onClick={onShareClick}
                            height={34}
                        /> */}
                        <PrimaryCta
                            invertSmall
                            onClick={onDownloadClick}
                            iconPosition="left"
                            iconName="pdfIcon"
                            isLoading={pdfLoading}
                            padding="0px 12px"
                            fontSize="font_size_small"
                            text="Download"
                            disabled={pdfLoading}
                            height={34}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default AnalyticsHeaderTop;
